@if (notification(); as n) {
  <div class="detail-type">
    <span
      class="notification-dot"
      [class.notification-dot--message]="n.notificationType === NotificationTypes.message"
      [class.notification-dot--alert]="n.notificationType === NotificationTypes.alert"
    ></span>
    <span class="detail-type__label">{{ typeLabel() }}</span>
  </div>

  <p class="detail-message">{{ n.message }}</p>

  <p class="detail-timestamp">{{ n.createdDateTime | date: 'medium' }}</p>

  <button type="button" class="detail-dismiss-btn" (click)="dismiss()">
    Dismiss
  </button>
}
